import { handleResponseOld, makeGet } from './helpers';
import transform from './wonLostCatalogsTransform';

/**
 * @category Mainhost API
 * @see fetchWonItems
 */
type FetchWonItemsParams = {
    authToken: string;
    bidderId: number;
    deployment: string;
    page?: number;
    pageSize?: number;
};

type FetchWonItemsResponse = {
    data: {
        catalogs: [
            {
                catalogId: number;
                currency: string;
                invoice?: {
                    balanceDue: number;
                    disputeReason: any;
                    hammerPrice: number;
                    invoiceId: any;
                    openDispute: any; // intermittent 0, null or "0" coming in here
                    paidStatus: string;
                    sent: boolean;
                };
                items: [
                    {
                        hammerPrice: number;
                        hammerPriceAtomic: number;
                        itemId: number;
                        lotNumber: string;
                        title: string;
                    }
                ];
                liveAuctioneersPayments: boolean;
                saleStartTs: number;
                sellerId: number;
                sellerName: string;
                title: string;
            }
        ];
        count: number;
    };
    message: string;
    success: boolean;
};
/**
 * fetches won items for given bidderId via Get to Mainhost API
 * @function fetchWonItems
 * @category Mainhost API
 * @param {FetchWonItemsParams}
 * @see https://mainhost-DEPLOYMENT.liveauctioneers.com/APIPATH/api/bidders/${bidderId}/wonitems
 * @see https://github.com/LIVEauctioneers/mainhost-prod/blob/master/httpdocs/api/bidders.php#L81
 */
export const fetchWonItems = ({ authToken, bidderId, deployment, page = 1, pageSize = 1250 }: FetchWonItemsParams) => {
    return new Promise<FetchWonItemsResponse>((resolve, reject) => {
        const request = makeGet({
            authToken,
            deployment,
            path: `<MAINHOST-API>api/bidders/${bidderId}/wonitems`,
            queryParams: { client_version: '5.0', page, pagesize: pageSize },
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response, transform }));
    });
};

type FetchDisputedWonItemsResponse = {
    data: {
        catalogs: [
            {
                catalogId: number;
                currency: string;
                invoice?: {
                    balanceDue: number;
                    disputeReason: any;
                    hammerPrice: number;
                    invoiceId: any;
                    openDispute: any; // intermittent 0, null or "0" coming in here
                    paidStatus: string;
                    sent: boolean;
                };
                items: [
                    {
                        hammerPrice: number;
                        hammerPriceAtomic: number;
                        itemId: number;
                        lotNumber: string;
                        title: string;
                    }
                ];
                liveAuctioneersPayments: boolean;
                saleStartTs: number;
                sellerId: number;
                sellerName: string;
                title: string;
            }
        ];
        count: number;
    };
    message: string;
    success: boolean;
};
/**
 * gets disputed won items for given bidderId via Get to Mainhost API
 * @function fetchDisputedWonItems
 * @category Mainhost API
 * @param {FetchWonItemsParams}
 * @see https://mainhost-DEPLOYMENT.liveauctioneers.com/APIPATH/api/bidders/${bidderId}/disputed
 * @see https://github.com/LIVEauctioneers/mainhost-prod/blob/master/httpdocs/api/bidders.php#L104
 */
export const fetchDisputedWonItems = ({
    authToken,
    bidderId,
    deployment,
    page = 1,
    pageSize = 1250,
}: FetchWonItemsParams) => {
    return new Promise<FetchDisputedWonItemsResponse>((resolve, reject) => {
        const request = makeGet({
            authToken,
            deployment,
            path: `<MAINHOST-API>api/bidders/${bidderId}/disputed`,
            queryParams: { client_version: '5.0', page, pagesize: pageSize },
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response, transform }));
    });
};
